export const ContentProp = {
  name: "Content",
  nameI18n: "builder_ui.block_props_category.content",
} as const;

export const DesignProp = {
  name: "Design",
  nameI18n: "builder_ui.block_props_category.design",
} as const;

export const SizeProp = {
  name: "Size",
  nameI18n: "builder_ui.block_props_category.size",
} as const;

export const BorderProp = {
  name: "Border",
  nameI18n: "builder_ui.block_props_category.border",
} as const;

export const PaddingsProp = {
  name: "Paddings",
  nameI18n: "builder_ui.block_props_category.paddings",
} as const;

export const ColorsProp = {
  name: "Colors",
  nameI18n: "builder_ui.block_props_category.colors",
} as const;

export const LayoutProp = {
  name: "Layout",
  nameI18n: "builder_ui.block_props_category.layout",
} as const;

export const BackgroundProp = {
  name: "Background",
  nameI18n: "builder_ui.block_props_category.background",
} as const;

export const MarginsProp = {
  name: "Margins",
  nameI18n: "builder_ui.block_props_category.margins",
} as const;

export const CornersProp = {
  name: "Corners",
  nameI18n: "builder_ui.block_props_category.corners",
} as const;

export const SizingProp = {
  name: "Sizing",
  nameI18n: "builder_ui.block_props_category.sizing",
} as const;

export const GeneralProp = {
  name: "General",
  nameI18n: "builder_ui.block_props_category.general",
} as const;

const AllPropCategories = [
  ContentProp,
  DesignProp,
  SizeProp,
  BorderProp,
  PaddingsProp,
  ColorsProp,
  GeneralProp,
  LayoutProp,
  BackgroundProp,
  MarginsProp,
  CornersProp,
  SizingProp,
] as const;

const AllPropCategoriesNames = AllPropCategories.map(category => category.name);

export type PropCategoryName = (typeof AllPropCategoriesNames)[number];
